import { Box, Typography } from "@mui/material";

interface EmptyChartStateProps {
  message?: string;
  submessage?: string;
}

export const EmptyChartState = ({
  message = "No data available",
  submessage = "Adjust your filters to see matching results.",
}: EmptyChartStateProps) => {
  return (
    <Box
      height="100%"
      minHeight={200}
      display="flex"
      flexDirection="column"
      justifyContent="center"
      alignItems="center"
      textAlign="center"
      color="text.secondary"
      px={2}
    >
      <Typography variant="subtitle1" fontWeight={500}>
        {message}
      </Typography>
      <Typography variant="body2">{submessage}</Typography>
    </Box>
  );
};
